import script from "./RecommendEditReceiveAnnounce.vue?vue&type=script&lang=ts&setup=true"
export * from "./RecommendEditReceiveAnnounce.vue?vue&type=script&lang=ts&setup=true"

import "./RecommendEditReceiveAnnounce.vue?vue&type=style&index=0&id=4b373d1e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b373d1e"]])

export default __exports__